import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Suspense, lazy, useState } from 'react';

import { CommandPalette } from '@/components/command/command-palette';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useShortcut } from '@/hooks/use-shortcut';

// Devtools sólo en dev. Lazy import para que el chunk no entre al bundle
// de producción.
const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    )
  : (): null => null;

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((mod) => ({
        default: mod.ReactQueryDevtools,
      })),
    )
  : (): null => null;

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <TooltipProvider delayDuration={200} skipDelayDuration={300}>
      <Outlet />
      <CommandPalette />
      {import.meta.env.DEV && <DevtoolsToggle />}
    </TooltipProvider>
  );
}

// Devtools (Router + Query) escondidas por default. Se muestran sólo bajo
// ⌘+Shift+D (Mac) / Ctrl+Shift+D (Win/Linux). Patrón Linear: el dev se opt-in
// cuando lo necesita; mientras tanto la UI no se contamina con botones
// flotantes que el usuario no entiende.
function DevtoolsToggle() {
  const [open, setOpen] = useState(false);
  useShortcut('cmd+shift+d', () => setOpen((prev) => !prev));

  if (!open) return null;
  return (
    <>
      <Suspense fallback={null}>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
      <Suspense fallback={null}>
        <ReactQueryDevtools initialIsOpen buttonPosition="bottom-left" />
      </Suspense>
    </>
  );
}
